"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Updater = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_router_dom_1 = require("react-router-dom");
class Updater extends React.Component {
    componentDidMount() {
        this.componentDidUpdate();
    }
    componentDidUpdate() {
        const s = new URLSearchParams(this.props.location.search);
        const t = s.get('q');
        if (this.props.tagStore) {
            this.props.tagStore.init(t ? t.split('|') : []);
        }
    }
    render() {
        return null;
    }
}
exports.Updater = Updater;
exports.default = react_router_dom_1.withRouter(mobx_react_1.inject('tagStore')(mobx_react_1.observer(Updater)));
